import { render, staticRenderFns } from "./checkMessage.vue?vue&type=template&id=d450c9ae&scoped=true&"
import script from "./checkMessage.vue?vue&type=script&lang=js&"
export * from "./checkMessage.vue?vue&type=script&lang=js&"
import style0 from "./checkMessage.vue?vue&type=style&index=0&id=d450c9ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d450c9ae",
  null
  
)

export default component.exports